import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import Beneficiary from '../Models/Beneficiary';
import { AppService, Types } from '../CommonParticipantTypes';

export interface IBeneficiariesApiClient {

    /**
     * Gets a list of nominated beneficiaries.
     * @param participantId The unique identifier of the participant to retrieve.
     * @returns A list of beneficiaries.
     */
    getBeneficiaries(participantId: string): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>>;

    /**
     * Gets the nominated beneficiaries for the currently authenticated participant.
     * @returns A list of beneficiaries.
     */
    getMyBeneficiaries(): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>>;

    /**
     * Saves beneficiaries.
     * @param beneficiaries The beneficiary data including guardian info if minor.
     * @returns Action result.
     */
    saveBeneficiaries(beneficiaries: Array<Model.PartialPlainObject<Beneficiary>>): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>>;

    /** 
     * Saves beneficiaries.
     * @param beneficiaries The beneficiary data including guardian info if minor.
     * @returns Action result.
     */
    saveMyBeneficiaries(beneficiaries: Array<Model.PartialPlainObject<Beneficiary>>): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>>;

    // Client only properties / methods
}

@injectable()
export default class BeneficiariesApiClient extends Data.ApiClientBase implements IBeneficiariesApiClient {

    constructor(config = AppService.get(Types.Shared.Config)) {
        super(`${config.ParticipantsApi.ApiPath}/Beneficiaries`);
    }

    public getBeneficiaries(participantId: string): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>> {
        return this.axios.get(`${this.apiPath}?participantId=${encodeURIComponent(participantId)}`);
    }

    public getMyBeneficiaries(): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>> {
        return this.axios.get(`${this.apiPath}/me`);
    }

    public saveBeneficiaries(beneficiaries: Array<Model.PartialPlainObject<Beneficiary>>): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>> {
        return this.axios.post(`${this.apiPath}`, beneficiaries);
    }

    public saveMyBeneficiaries(beneficiaries: Array<Model.PartialPlainObject<Beneficiary>>): AxiosPromise<Array<Model.PlainTrackedObject<Beneficiary>>> {
        return this.axios.post(`${this.apiPath}/me`, beneficiaries);
    }
}